(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesListController', InvoicesListController);

    InvoicesListController.$inject = ['$filter', '$state', 'invoices', 'InvoicesService', 'ExpoService', 'SellerService'];

    function InvoicesListController($filter, $state, invoices, InvoicesService, ExpoService, SellerService) {
        var vm = this;

        vm.invoice_type = $state.current.data.invoice_type;
        vm.title = $state.current.data.title;

        vm.invoices = invoices.data.data;

        vm.expos        = [];
        vm.expoSelected = [];

        vm.sellers        = [];
        vm.sellerSelected = [];

        vm.exhibitorName = '';

        vm.types = [
            {
                name: 'All invoices'
            },
            {
                id: 'invoice_paid',
                name: 'All invoices paid'
            },
            {
                id: 'waiting_invoice',
                name: 'Invoices not Issued'
            },
            {
                id: 'invoice_created',
                name: 'Created but not paid'
            }
        ];
        vm.typeSelected = [];
        vm.typeNameSelected;

        vm.selectOptionAll = [{
            name: '--- All ---'
        }];

        vm.selectExposOptionAll = [
            {
                id: 'active',
                name: '--- Active Expos ---'
            },
            {
                name: '--- All Expos ---'
            },
        ];

        vm.loadExpos      = loadExpos;
        vm.loadSellers    = loadSellers;
        vm.getByFilter    = getByFilter;
        // vm.viewClientData = viewClientData;
        // vm.remove          = remove;

        vm.getStatusLabel = getStatusLabel;
        vm.getStatusClass = getStatusClass;

        vm.getProfileLabel = getProfileLabel;
        vm.getProfileClass = getProfileClass;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = invoices.data.total;
        vm.currentPage  = invoices.data.current_page;
        vm.lastPage     = invoices.data.lastPage;
        vm.itemsPerPage = invoices.data.per_page;
        vm.page         = 1;


        activate();


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            vm.loadExpos();
            vm.loadSellers();            
        }


        function loadExpos() {
            if (vm.invoice_type == 'expo') {
                ExpoService.getExposForSelect().then(function(response) {
                    vm.expos = vm.selectExposOptionAll.concat(response.data);
                    vm.expoSelected = $filter('filter')(vm.expos, {id: 'active'})[0];
                }).catch(function(err) {
                });
            } else {
                ExpoService.getExposVirtualFair().then(function(response){
                    vm.expos = vm.selectExposOptionAll.concat(response.data);
                    vm.expoSelected = $filter('filter')(vm.expos, {id: 'active'})[0];
                }).catch(function(err) {
                });
            }
            
        }


        function loadSellers() {
            SellerService.getAll().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }        

        function getByFilter() {
            vm.query = {};

            if (vm.expoSelected) {
                if (vm.invoice_type == 'expo') {
                    vm.query['expo_id']         = vm.expoSelected.id;
                } else {
                    vm.query['virtual_fair_id'] = vm.expoSelected.id;
                }
            }

            if (vm.typeSelected) {
                vm.query['financial_status'] = vm.typeSelected.id;
            }

            vm.query['seller_id']      = vm.sellerSelected.id;
            vm.typeNameSelected        = vm.typeSelected.name;
            vm.query['page']           = vm.page;

            if (vm.exhibitorName !== '') {
                vm.query['exhibitor_name'] = vm.exhibitorName;
            }

            InvoicesService.getByFilter(vm.query, vm.invoice_type).then(function(response) {
                vm.invoices = response.data.data; 
                vm.totalItems = response.data.total; 
                vm.to = response.data.to;                              
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }        

        function getStatusLabel(status) {
            if (status === 'waiting_invoice')
                return 'Invoices not Issued';
            else if (status === 'invoice_created')
                return 'Created but not paid';
            else if (status === 'invoice_paid')
                return 'All invoices paid';
        }

        function getStatusClass(status) {
            if (status === 'waiting_invoice')
                return 'label-danger';
            else if (status === 'invoice_created')
                return 'label-warning';
            else if (status === 'invoice_paid')
                return 'label-success';
        }

        function getProfileLabel(percent) {
            return percent + '% complete';
        }

        function getProfileClass(percent) {
            if (percent >= 75)
                return 'label-success';
            else if (percent >= 50)
                return 'label-warning';
            else
                return 'label-danger';
        }
    }

})();